import DialogComponent from "components/Dialog";

export default class ResponsibleDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            info: false,
            id: false
        };
    }

    title = "Выбор ответственного";

    show(info, hideCb) {
        this.state.info = info;
        this.dialogSaveLabel = "Назначить";
        this.hidCb = hideCb;
        super.show();
    }

    save() {
        const info = {
            consultantId: this.state.id,
            id: this.state.info.id
        };

        if (this.hidCb?.apply)
            this.hidCb(info);

        this.hide();
    }

    renderContent() {
        //const { info } = this.state;

        return (
            <div className="content flex col gap16">
                {this.insertSelectDoctor({
                    value: this.state.id,
                    type: "responsible",
                    onClick: this.changeState.bind(this, "id")
                })}
            </div>
        );
    }
}

